document.addEventListener('DOMContentLoaded', function() {
  // Este archivo puede ser utilizado para futuras personalizaciones de JavaScript.
});
